import { render, staticRenderFns } from "./card-good-list.vue?vue&type=template&id=1568d1fc&scoped=true"
import script from "./card-good-list.vue?vue&type=script&lang=js"
export * from "./card-good-list.vue?vue&type=script&lang=js"
import style0 from "./card-good-list.vue?vue&type=style&index=0&id=1568d1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568d1fc",
  null
  
)

export default component.exports